import type { ReactNode } from 'react';
import { TextButton } from '@zillow/constellation-10';

import type { Lease } from '../../models';
import Property from '../../models/Property';

type Props = {
  property?: Property | null;
  listingAlias?: string;
  lease?: Lease | null;
  withMoveInCosts?: boolean;
  disabled?: boolean;
  children?: ReactNode;
};

/** Takes the models rather than an href so no call site can omit the pending-query guard. */
export function SetUpPaymentsLink({
  property,
  listingAlias,
  lease,
  withMoveInCosts = false,
  disabled = false,
  children = 'Set up payments',
}: Props) {
  const alias = property ? property.listingAlias : listingAlias;
  const encodedLeaseId = lease?.encodedId;

  let href: string | undefined;
  if (!disabled && alias && encodedLeaseId) {
    href = withMoveInCosts
      ? Property.getPaymentsDashboardPathWithMoveinCostEnabled(alias, encodedLeaseId)
      : Property.getPaymentsDashboardPath(alias, encodedLeaseId);
  }

  return (
    <TextButton tone="brand" disabled={disabled || !href} asChild>
      <a href={href}>{children}</a>
    </TextButton>
  );
}
